<template>
  <DialogTile title="Activate account">
      <Notification :type="n_type" :message="n_message" />
      <router-link to="/login">Login now</router-link>
  </DialogTile>
</template>

<script>
import { auth } from "../schmucklicloud";

export default {
    data(){
        return {
            n_type: "",
            n_message: ""
        }
    },

    mounted() {
        var token = window.location.href.split("?")[1].replace("token=", "");
        auth.activateUser(token).then(function (response){
            if(response.isOK) {
                this.n_type = "success";
            } else {
                this.n_type = "error";
            }

            this.n_message = response.message;
        }.bind(this));
    }
}
</script>

<style>

</style>